export default "__VITE_ASSET__C8MIs5Ig__"